export type VaiTro = "Admin" | "Nhanvien" | "Quanlykho";

const ADMIN_ROLES: VaiTro[] = ["Admin", "Quanlykho"];

/** Bỏ dấu tiếng Việt + khoảng trắng thừa để so chức vụ cho chắc. */
function toKey(chucVu: string): string {
  return chucVu
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/gi, "d")
    .replace(/\s+/g, "")
    .trim()
    .toLowerCase();
}

/**
 * Chức vụ trong database có thể được nhập nhiều kiểu (Admin / Quanlykho /
 * Nhân viên / "Quản lý kho"…). Chuẩn hoá về đúng 3 giá trị gốc để việc phân
 * quyền không bị lọt chỉ vì khác dấu hay khác khoảng trắng.
 */
export function normalizeRole(chucVu: string | null | undefined): VaiTro | null {
  if (!chucVu) return null;
  const key = toKey(chucVu);
  if (key === "admin" || key === "quantri" || key === "quantrivien") return "Admin";
  if (key === "quanlykho") return "Quanlykho";
  if (key === "nhanvien" || key === "staff" || key === "employee") return "Nhanvien";
  return null;
}

export function isAdminRole(chucVu: string | null | undefined): boolean {
  const role = normalizeRole(chucVu);
  return role !== null && ADMIN_ROLES.includes(role);
}

export function isTrueAdmin(chucVu: string | null | undefined): boolean {
  return normalizeRole(chucVu) === "Admin";
}

export const ROLE_LABELS: Record<VaiTro, string> = {
  Admin: "Quản trị viên",
  Nhanvien: "Nhân viên",
  Quanlykho: "Quản lý kho",
};

export function getRoleLabel(chucVu: string | null | undefined): string {
  const role = normalizeRole(chucVu);
  return role ? ROLE_LABELS[role] : "Nhân viên";
}